import React from 'react';
import {
  Icon16Pause,
  Icon16Play,
  Icon16Replay,
  Icon16Spinner,
  Icon20Pause,
  Icon20Play,
  Icon20ReplayOutline,
  Icon20Spinner,
} from '@vkontakte/icons';
import { AudioPlayerStatus } from '@dui/MediaPlayerController/AudioPlayerController';

export const statusIconMapper: Record<
  16 | 20,
  Record<AudioPlayerStatus | 'idle', React.FunctionComponent<{ fill?: string }>>
> = {
  20: {
    idle: Icon20Play,
    destroyed: Icon20Play,
    loading: Icon20Spinner,
    playing: Icon20Pause,
    paused: Icon20Play,
    failed: Icon20ReplayOutline,
    ended: Icon20Play,
  },
  16: {
    idle: Icon16Play,
    destroyed: Icon16Play,
    loading: Icon16Spinner,
    playing: Icon16Pause,
    paused: Icon16Play,
    failed: Icon16Replay,
    ended: Icon16Play,
  },
};
